import styled from "styled-components";

export const ShumokuMasterManagementMainStyled = styled.div`
  flex: 1;
`;
